import Layout from "../components/Layout"

export default function Privacy() {
  return (
    <Layout>
      <h1 className="font-serif text-3xl text-cream mb-8">Privacy Policy</h1>
      <div className="text-stone-400 space-y-4 text-sm leading-relaxed">
        <p>Last updated: June 2026</p>
        <p>This is a personal music sharing site. We collect minimal data.</p>
        <h2 className="text-stone-200 text-base mt-6">Data we store</h2>
        <p>Waitlist entries (email and optional phone number). That's it.</p>
        <h2 className="text-stone-200 text-base mt-6">Contact</h2>
        <p>
          Email{" "}
          <a href="mailto:hello@octave.fm" className="text-stone-300 hover:text-white">
            hello@octave.fm
          </a>
        </p>
      </div>
    </Layout>
  )
}
